const motherTongues = [
    {
        value: "af",
        label: "Afrikaans",
    },
    {
        value: "hr",
        label: "Croatian",
    },
    {
        value: "el",
        label: "Greek",
    },
    {
        value: "pl",
        label: "Polish",
    },
    {
        value: "sx",
        label: "Sutu",
    },
    {
        value: "sq",
        label: "Albanian",
    },
    {
        value: "cs",
        label: "Czech",
    },
    {
        value: "gu",
        label: "Gujurati",
    },
    {
        value: "pt",
        label: "Portuguese",
    },
    {
        value: "sw",
        label: "Swahili",
    },
    {
        value: "ar",
        label: "Arabic (Standard)",
    },
    {
        value: "da",
        label: "Danish",
    },
    {
        value: "ht",
        label: "Haitian",
    },
    {
        value: "pt-br",
        label: "Portuguese (Brazil)",
    },
    {
        value: "sv",
        label: "Swedish",
    },
    {
        value: "ar-dz",
        label: "Arabic (Algeria)",
    },
    {
        value: "nl",
        label: "Dutch (Standard)",
    },
    {
        value: "he",
        label: "Hebrew",
    },
    {
        value: "pa",
        label: "Punjabi",
    },
    {
        value: "sv-fi",
        label: "Swedish (Finland)",
    },
    {
        value: "ar-bh",
        label: "Arabic (Bahrain)",
    },
    {
        value: "nl-be",
        label: "Dutch (Belgian)",
    },
    {
        value: "hi",
        label: "Hindi",
    },
    {
        value: "pa-in",
        label: "Punjabi (India)",
    },
    {
        value: "sv-sv",
        label: "Swedish (Sweden)",
    },
    {
        value: "ar-eg",
        label: "Arabic (Egypt)",
    },
    {
        value: "en",
        label: "English",
    },
    {
        value: "hu",
        label: "Hungarian",
    },
    {
        value: "pa-pk",
        label: "Punjabi (Pakistan)",
    },
    {
        value: "ta",
        label: "Tamil",
    },
    {
        value: "ar-iq",
        label: "Arabic (Iraq)",
    },
    {
        value: "en-au",
        label: "English (Australia)",
    },
    {
        value: "is",
        label: "Icelandic",
    },
    {
        value: "qu",
        label: "Quechua",
    },
    {
        value: "tt",
        label: "Tatar",
    },
    {
        value: "ar-jo",
        label: "Arabic (Jordan)",
    },
    {
        value: "en-bz",
        label: "English (Belize)",
    },
    {
        value: "id",
        label: "Indonesian",
    },
    {
        value: "rm",
        label: "Rhaeto-Romanic",
    },
    {
        value: "te",
        label: "Teluga",
    },
    {
        value: "ar-kw",
        label: "Arabic (Kuwait)",
    },
    {
        value: "en-ca",
        label: "English (Canada)",
    },
    {
        value: "iu",
        label: "Inuktitut",
    },
    {
        value: "ro",
        label: "Romanian",
    },
    {
        value: "th",
        label: "Thai",
    },
    {
        value: "ar-lb",
        label: "Arabic (Lebanon)",
    },
    {
        value: "en-ie",
        label: "English (Ireland)",
    },
    {
        value: "ga",
        label: "Irish",
    },
    {
        value: "ro-mo",
        label: "Romanian (Moldavia)",
    },
    {
        value: "tig",
        label: "Tigre",
    },
    {
        value: "ar-ly",
        label: "Arabic (Libya)",
    },
    {
        value: "en-jm",
        label: "English (Jamaica)",
    },
    {
        value: "it",
        label: "Italian (Standard)",
    },
    {
        value: "ru",
        label: "Russian",
    },
    {
        value: "ts",
        label: "Tsonga",
    },
    {
        value: "ar-ma",
        label: "Arabic (Morocco)",
    },
    {
        value: "en-nz",
        label: "English (New Zealand)",
    },
    {
        value: "it-ch",
        label: "Italian (Switzerland)",
    },
    {
        value: "ru-mo",
        label: "Russian (Moldavia)",
    },
    {
        value: "tn",
        label: "Tswana",
    },
    {
        value: "ar-om",
        label: "Arabic (Oman)",
    },
    {
        value: "en-ph",
        label: "English (Philippines)",
    },
    {
        value: "ja",
        label: "Japanese",
    },
    {
        value: "sz",
        label: "Sami (Lappish)",
    },
    {
        value: "tr",
        label: "Turkish",
    },
    {
        value: "ar-qa",
        label: "Arabic (Qatar)",
    },
    {
        value: "en-za",
        label: "English (South Africa)",
    },
    {
        value: "kn",
        label: "Kannada",
    },
    {
        value: "sg",
        label: "Sango",
    },
    {
        value: "tk",
        label: "Turkmen",
    },
    {
        value: "ar-sa",
        label: "Arabic (Saudi Arabia)",
    },
    {
        value: "en-tt",
        label: "English (Trinidad & Tobago)",
    },
    {
        value: "ks",
        label: "Kashmiri",
    },
    {
        value: "sa",
        label: "Sanskrit",
    },
    {
        value: "uk",
        label: "Ukrainian",
    },
    {
        value: "ar-sy",
        label: "Arabic (Syria)",
    },
    {
        value: "en-gb",
        label: "English (United Kingdom)",
    },
    {
        value: "kk",
        label: "Kazakh",
    },
    {
        value: "sc",
        label: "Sardinian",
    },
    {
        value: "hsb",
        label: "Upper Sorbian",
    },
    {
        value: "ar-tn",
        label: "Arabic (Tunisia)",
    },
    {
        value: "en-us",
        label: "English (United States)",
    },
    {
        value: "km",
        label: "Khmer",
    },
    {
        value: "ur",
        label: "Urdu",
    },
    {
        value: "ar-ae",
        label: "Arabic (U.A.E.)",
    },
    {
        value: "en-zw",
        label: "English (Zimbabwe)",
    },
    {
        value: "ky",
        label: "Kirghiz",
    },
    {
        value: "sd",
        label: "Sindhi",
    },
    {
        value: "ve",
        label: "Venda",
    },
    {
        value: "ar-ye",
        label: "Arabic (Yemen)",
    },
    {
        value: "eo",
        label: "Esperanto",
    },
    {
        value: "tlh",
        label: "Klingon",
    },
    {
        value: "si",
        label: "Singhalese",
    },
    {
        value: "vi",
        label: "Vietnamese",
    },
    {
        value: "et",
        label: "Estonian",
    },
    {
        value: "ko",
        label: "Korean",
    },
    {
        value: "sr",
        label: "Serbian",
    },
    {
        value: "vo",
        label: "Volapuk",
    },
    {
        value: "hy",
        label: "Armenian",
    },
    {
        value: "fo",
        label: "Faeroese",
    },
    {
        value: "ko-kp",
        label: "Korean (North Korea)",
    },
    {
        value: "sk",
        label: "Slovak",
    },
    {
        value: "wa",
        label: "Walloon",
    },
    {
        value: "as",
        label: "Assamese",
    },
    {
        value: "fa",
        label: "Farsi",
    },
    {
        value: "ko-kr",
        label: "Korean (South Korea)",
    },
    {
        value: "sl",
        label: "Slovenian",
    },
    {
        value: "cy",
        label: "Welsh",
    },
    {
        value: "ast",
        label: "Asturian",
    },
    {
        value: "fj",
        label: "Fijian",
    },
    {
        value: "la",
        label: "Latin",
    },
    {
        value: "so",
        label: "Somani",
    },
    {
        value: "xh",
        label: "Xhosa",
    },
    {
        value: "az",
        label: "Azerbaijani",
    },
    {
        value: "fi",
        label: "Finnish",
    },
    {
        value: "lv",
        label: "Latvian",
    },
    {
        value: "sb",
        label: "Sorbian",
    },
    {
        value: "ji",
        label: "Yiddish",
    },
    {
        value: "eu",
        label: "Basque",
    },
    {
        value: "fr",
        label: "French (Standard)",
    },
    {
        value: "lt",
        label: "Lithuanian",
    },
    {
        value: "es",
        label: "Spanish",
    },
    {
        value: "zu",
        label: "Zulu",
    },
    {
        value: "bg",
        label: "Bulgarian",
    },
    {
        value: "fr-be",
        label: "French (Belgium)",
    },
    {
        value: "lb",
        label: "Luxembourgish",
    },
    {
        value: "es-ar",
        label: "Spanish (Argentina)",
    },
    {
        value: "be",
        label: "Belarusian",
    },
    {
        value: "fr-ca",
        label: "French (Canada)",
    },
    {
        value: "mk",
        label: "FYRO Macedonian",
    },
    {
        value: "es-bo",
        label: "Spanish (Bolivia)",
    },
    {
        value: "bn",
        label: "Bengali",
    },
    {
        value: "fr-fr",
        label: "French (France)",
    },
    {
        value: "ms",
        label: "Malay",
    },
    {
        value: "es-cl",
        label: "Spanish (Chile)",
    },
    {
        value: "bs",
        label: "Bosnian",
    },
    {
        value: "fr-lu",
        label: "French (Luxembourg)",
    },
    {
        value: "ml",
        label: "Malayalam",
    },
    {
        value: "es-co",
        label: "Spanish (Colombia)",
    },
    {
        value: "br",
        label: "Breton",
    },
    {
        value: "fr-mc",
        label: "French (Monaco)",
    },
    {
        value: "mt",
        label: "Maltese",
    },
    {
        value: "es-cr",
        label: "Spanish (Costa Rica)",
    },
    {
        value: "fr-ch",
        label: "French (Switzerland)",
    },
    {
        value: "mi",
        label: "Maori",
    },
    {
        value: "es-do",
        label: "Spanish (Dominican Republic)",
    },
    {
        value: "my",
        label: "Burmese",
    },
    {
        value: "fy",
        label: "Frisian",
    },
    {
        value: "mr",
        label: "Marathi",
    },
    {
        value: "es-ec",
        label: "Spanish (Ecuador)",
    },
    {
        value: "ca",
        label: "Catalan",
    },
    {
        value: "fur",
        label: "Friulian",
    },
    {
        value: "mo",
        label: "Moldavian",
    },
    {
        value: "es-sv",
        label: "Spanish (El Salvador)",
    },
    {
        value: "ch",
        label: "Chamorro",
    },
    {
        value: "gd",
        label: "Gaelic (Scots)",
    },
    {
        value: "nv",
        label: "Navajo",
    },
    {
        value: "es-gt",
        label: "Spanish (Guatemala)",
    },
    {
        value: "ce",
        label: "Chechen",
    },
    {
        value: "gd-ie",
        label: "Gaelic (Irish)",
    },
    {
        value: "ng",
        label: "Ndonga",
    },
    {
        value: "es-hn",
        label: "Spanish (Honduras)",
    },
    {
        value: "zh",
        label: "Chinese",
    },
    {
        value: "zh-hant",
        label: "Chinese (traditional)",
    },
    {
        value: "zh",
        label: "Chinese",
    },
    {
        value: "gl",
        label: "Galacian",
    },
    {
        value: "ne",
        label: "Nepali",
    },
    {
        value: "es-mx",
        label: "Spanish (Mexico)",
    },
    {
        value: "zh-hk",
        label: "Chinese (Hong Kong)",
    },
    {
        value: "ka",
        label: "Georgian",
    },
    {
        value: "no",
        label: "Norwegian",
    },
    {
        value: "es-ni",
        label: "Spanish (Nicaragua)",
    },
    {
        value: "zh-cn",
        label: "Chinese (PRC)",
    },
    {
        value: "de",
        label: "German (Standard)",
    },
    {
        value: "nb",
        label: "Norwegian (Bokmal)",
    },
    {
        value: "es-pa",
        label: "Spanish (Panama)",
    },
    {
        value: "zh-sg",
        label: "Chinese (Singapore)",
    },
    {
        value: "de-at",
        label: "German (Austria)",
    },
    {
        value: "nn",
        label: "Norwegian (Nynorsk)",
    },
    {
        value: "es-py",
        label: "Spanish (Paraguay)",
    },
    {
        value: "zh-tw",
        label: "Chinese (Taiwan)",
    },
    {
        value: "de-de",
        label: "German (Germany)",
    },
    {
        value: "oc",
        label: "Occitan",
    },
    {
        value: "es-pe",
        label: "Spanish (Peru)",
    },
    {
        value: "cv",
        label: "Chuvash",
    },
    {
        value: "de-li",
        label: "German (Liechtenstein)",
    },
    {
        value: "or",
        label: "Oriya",
    },
    {
        value: "es-pr",
        label: "Spanish (Puerto Rico)",
    },
    {
        value: "co",
        label: "Corsican",
    },
    {
        value: "de-lu",
        label: "German (Luxembourg)",
    },
    {
        value: "om",
        label: "Oromo",
    },
    {
        value: "es-es",
        label: "Spanish (Spain)",
    },
    {
        value: "cr",
        label: "Cree",
    },
    {
        value: "de-ch",
        label: "German (Switzerland)",
    },
    {
        value: "es-uy",
        label: "Spanish (Uruguay)",
    },
    {
        value: "fa-ir",
        label: "Persian/Iran",
    },
    {
        value: "es-ve",
        label: "Spanish (Venezuela)",
    },
];

export default motherTongues;

export const isMotherTongue = (motherTongue : string) => {
    return !!motherTongues.find(({ value }) => motherTongue === value);
};
